import courseBrief from "./courseBrief";

const courseBriefService = [
    {
        matcher: 'courseBrief',
        reply: config => {
            return [200, courseBrief];
        }
    }
]

export default courseBriefService;